export const SITE = {
  name: 'B.E. Holbrooks Co.',
  phone: '704-888-2411',
  phoneHref: 'tel:+17048882411',
  email: 'beh@beholbrooks.com',
  address: '204 West Stanly Street',
  cityStateZip: 'Stanfield, NC 28163',
  domain: 'https://beholbrooks.com',
  years: '60+',
};

export const IMAGES = {
  heroTech: '/assets/team-van.webp',
  acRepair: 'https://images.pexels.com/photos/5463582/pexels-photo-5463582.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  plumbing: 'https://images.unsplash.com/photo-1706622710966-331f0d5127e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxwbHVtYmVyJTIwZml4aW5nJTIwcGlwZSUyMHNpbmslMjBiYXRocm9vbSUyMGNvbnRyYWN0b3J8ZW58MHx8fHwxNzg4ODg2Mzg5fDA&ixlib=rb-4.1.0&q=85',
  excavation: 'https://images.unsplash.com/photo-1649807438813-acc4489bcf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxleGNhdmF0b3IlMjBkaWdnaW5nJTIwdHJlbmNofGVufDB8fHx8MTc4NTI5NDMwNnww&ixlib=rb-4.1.0&q=85',
  rooftopAc: 'https://images.unsplash.com/photo-1642749776312-aa42ce20c9f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHxfHxodmFjJTIwdGVjaG5pY2lhbiUyMHdvcmtlciUyMGFpciUyMGNvbmRpdGlvbmVyJTIwcmVwYWlyfGVufDB8fHx8MTc4NzY0MDI2MXww&ixlib=rb-4.1.0&q=85',
  teamVan: '/assets/team-van.webp',
  techGauges: '/assets/tech-gauges.webp',
  techAmericanStandard: '/assets/tech-american-standard.webp',
  officeStaff: '/assets/office-staff.webp',
  storefront: '/assets/storefront.jpg',
  logo: '/assets/logo.jpg',
  logoTransparent: '/assets/logo-transparent.png',
  symbol: '/assets/symbol.jpg',
  americanStandard: '/assets/american-standard.jpg',
  historyFounders: '/assets/history-founders.jpg',
  historyTruck: '/assets/history-truck.webp',
  historyWorkshop: '/assets/history-workshop.webp',
};

export const CITIES = [
  { name: 'Stanfield', slug: 'stanfield' },
  { name: 'Locust', slug: 'locust' },
  { name: 'Charlotte', slug: 'charlotte' },
  { name: 'Concord', slug: 'concord' },
  { name: 'Kannapolis', slug: 'kannapolis' },
  { name: 'Albemarle', slug: 'albemarle' },
  { name: 'Norwood', slug: 'norwood' },
  { name: 'Monroe', slug: 'monroe' },
  { name: 'Gastonia', slug: 'gastonia' },
  { name: 'Huntersville', slug: 'huntersville' },
];

export const cityPath = (slug) => `/hvac-plumbing-${slug}-nc`;

export const NAV = [
  {
    label: 'Heating & Air', path: '/heating-air-conditioning', testid: 'nav-hvac',
    children: [
      { label: 'Heating & Air Conditioning', path: '/heating-air-conditioning' },
      { label: 'AC Repair', path: '/air-conditioning-repair-stanfield-nc' },
      { label: 'AC Installation & Replacement', path: '/air-conditioning-installation-stanfield-nc' },
      { label: 'Heating Repair & Installation', path: '/heating-repair-installation-stanfield-nc' },
    ],
  },
  { label: 'Plumbing', path: '/plumbing', testid: 'nav-plumbing' },
  { label: 'Excavation & Trenching', path: '/excavation-trenching', testid: 'nav-excavation' },
  { label: 'Indoor Air Quality', path: '/indoor-air-quality', testid: 'nav-iaq' },
  { label: 'Products', path: '/products', testid: 'nav-products' },
  { label: 'Promotions', path: '/promotions', testid: 'nav-promotions' },
  { label: 'Financing', path: '/financing', testid: 'nav-financing' },
  {
    label: 'Service Areas', path: '/service-areas', testid: 'nav-service-areas',
    children: [
      { label: 'All Service Areas', path: '/service-areas' },
      ...CITIES.map((c) => ({ label: `${c.name}, NC`, path: cityPath(c.slug) })),
    ],
  },
  { label: 'About', path: '/about', testid: 'nav-about' },
  { label: 'Contact', path: '/contact', testid: 'nav-contact' },
];

export const MARQUEE_ITEMS = [
  'Over 60 Years of Local Service',
  'Heating & Air Conditioning',
  'Residential & Commercial Plumbing',
  'Excavation & Trenching',
  'Indoor Air Quality',
  'American Standard Customer Care Dealer',
  'Stanfield & the Greater Charlotte Area',
  'Hardware & Garden Store on West Stanly Street',
];

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['HVACBusiness', 'Plumber'],
      '@id': `${SITE.domain}/#business`,
      name: SITE.name,
      url: SITE.domain,
      telephone: '+1-704-888-2411',
      email: SITE.email,
      image: `${SITE.domain}/assets/team-van.webp`,
      logo: `${SITE.domain}/assets/logo.jpg`,
      priceRange: '$$',
      foundingDate: '1962',
      description: 'Family-owned HVAC, plumbing, excavation, and trenching company serving Stanfield, NC and the greater Charlotte area for over 60 years. American Standard Customer Care Dealer.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: SITE.address,
        addressLocality: 'Stanfield',
        addressRegion: 'NC',
        postalCode: '28163',
        addressCountry: 'US',
      },
      geo: { '@type': 'GeoCoordinates', latitude: 35.2335, longitude: -80.4271 },
      areaServed: [
        ...CITIES.map((c) => ({ '@type': 'City', name: `${c.name}, NC` })),
        { '@type': 'State', name: 'North Carolina' },
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-704-888-2411',
        email: SITE.email,
        contactType: 'customer service',
        areaServed: 'North Carolina',
        availableLanguage: 'English',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'HVAC, Plumbing & Excavation Services',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AC Repair & Air Conditioning Service' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AC Installation & HVAC Replacement' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Heating Repair & Installation' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Heat Pump Service' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Residential & Commercial Plumbing' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Excavation & Trenching' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Indoor Air Quality Solutions' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'HVAC Financing' } },
        ],
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE.domain}/#organization`,
      name: SITE.name,
      url: SITE.domain,
      logo: `${SITE.domain}/assets/logo.jpg`,
      email: SITE.email,
      telephone: '+1-704-888-2411',
      foundingDate: '1962',
      address: {
        '@type': 'PostalAddress',
        streetAddress: SITE.address,
        addressLocality: 'Stanfield',
        addressRegion: 'NC',
        postalCode: '28163',
        addressCountry: 'US',
      },
    },
  ],
};

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE.domain}${it.path}`,
  })),
});

export const serviceSchema = (name, description, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  url: `${SITE.domain}${path}`,
  provider: { '@type': 'HVACBusiness', name: SITE.name, telephone: '+1-704-888-2411' },
  areaServed: CITIES.map((c) => ({ '@type': 'City', name: `${c.name}, NC` })),
});
